import ApplicationController from "./application_controller"

// Generic single-image persister -- also backs field-scoped uploads (fieldName/existingId), not just org logos.
export default class extends ApplicationController {
  static values = {
    url: String,
    exists: Boolean,
    paramKey: String,
    fieldName: String,
    existingId: String
  }

  save(event) {
    const file = event.detail.file
    if (!file) return

    const formData = new FormData()
    formData.append(`${this.paramKeyValue}[image]`, file)
    if (this.hasFieldNameValue) formData.append(`${this.paramKeyValue}[field_name]`, this.fieldNameValue)
    if (this.hasExistingIdValue) formData.append(`${this.paramKeyValue}[id]`, this.existingIdValue)

    const token = document.querySelector('meta[name="csrf-token"]')
    const buttons = this.element.querySelectorAll("button") // Remove/Select File/Upload -- lock all three during the request
    const uploadBtn = this.element.querySelector(".btn-primary")
    const originalText = uploadBtn.textContent
    buttons.forEach(btn => { btn.disabled = true })
    uploadBtn.textContent = "UPLOADING..."
    this.setBusy(true)

    fetch(this.urlValue, {
      method: this.existsValue ? "PATCH" : "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json", // without this Rails falls back to the HTML branch, which 500s on redirect_to(request.referrer) when there's no referrer
        "X-CSRF-Token": token ? token.content : ""
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        this.setBusy(false)
        buttons.forEach(btn => { btn.disabled = false })
        uploadBtn.textContent = originalText
        window.Gv3Toast.success("Image uploaded successfully.")
        setTimeout(() => window.location.reload(), 900) // let the toast be visible before the reload wipes it
      })
      .catch(() => {
        this.setBusy(false)
        buttons.forEach(btn => { btn.disabled = false })
        uploadBtn.textContent = originalText
        window.Gv3Toast.error("The image could not be uploaded. Please try again.")
      })
  }

  setBusy(isBusy) {
    const loader = document.getElementById("global-ajax-loader")
    if (loader) loader.classList.toggle("d-none", !isBusy)
  }
}
